import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var LogoContainer = styled.div.withConfig({
  displayName: "Logo__LogoContainer",
  componentId: "sc-8qg5kz-0"
})(["padding:1.5rem 0;"]);
var ImgLogo = styled.img.withConfig({
  displayName: "Logo__ImgLogo",
  componentId: "sc-8qg5kz-1"
})(["max-width:125px;margin-bottom:", "px;"], spacing.base);

var USPLogo = function USPLogo(_ref) {
  var fill = _ref.fill,
      src = _ref.src,
      alt = _ref.alt,
      svg = _ref.svg,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, ["fill", "src", "alt", "svg", "width"]);

  return React.createElement(LogoContainer, props, src && React.createElement(ImgLogo, {
    src: src,
    alt: alt
  }), svg && React.createElement(svg.svg, {
    style: {
      maxWidth: width || '125px'
    },
    fill: fill || 'black'
  }));
};

export default USPLogo;